import { toast } from "react-toastify";

const initialState = {
  officialData: null,
  athleteData: [],
};

const AvRatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ATHLETE_DATA":
      const updatedAthleteData = [...state.athleteData];
      const { data, index } = action.payload;
      const idExists = updatedAthleteData.some((item) => item.id === data.id);
      if (idExists) {
        toast.warning("All ready athlete added");
        return state;
      }

      updatedAthleteData[index] = data;

      return {
        ...state,
        athleteData: updatedAthleteData,
      };
    case "DELETE_ATHLETE_WITH_INDEX":
      const deleteIndex = action.payload;

      return {
        ...state,
        athleteData: state.athleteData.filter(
          (_, index) => index !== deleteIndex
        ),
      };
    case "CLEAR_ATHLETE_WITH_INDEX":
      return {
        ...state,
        athleteData: action.payload,
      };
    default:
      return state;
  }
};

export default AvRatingReducer;
